import { Pipe, PipeTransform } from '@angular/core';
import { ScheduleCalendarTime, INTERVAL_COUNT, START_HOUR, DEFAULT_INTERVAL_MINUTES } from '@libs/store';

@Pipe({
  name: 'scheduleTimeToGridRow',
  standalone: true,
})
export class ScheduleTimeToGridRowPipe implements PipeTransform {
  public transform(value: ScheduleCalendarTime): number {
    const { hour, minute } = value;

    return Math.round(INTERVAL_COUNT * (hour - START_HOUR) + minute / DEFAULT_INTERVAL_MINUTES) + 1;
  }
}
